const shader = `
#include <pathtracing_uniforms_and_defines>

uniform sampler2D tTriangleTexture;
uniform sampler2D tAABBTexture;
uniform sampler2D tMatrixTexture;
uniform sampler2D tAlbedoTexture; // 8 = max number of diffuse albedo textures per model

uniform int uGeoIndex;
uniform int uIgnoreGeoID;
uniform int uNumGeometries;
uniform int uNumSpheres;


/*
uniform int uNumLights;
uniform int uIndexedGeometry;
uniform int uNumCubes;
uniform int uNumCylinders;
*/


//float InvTextureWidth = 0.000244140625; // (1 / 4096 texture width)
//float InvTextureWidth = 0.00048828125;  // (1 / 2048 texture width)
//float InvTextureWidth = 0.0009765625;   // (1 / 1024 texture width)

#define INV_TEXTURE_WIDTH 0.000244140625
#define TEXTURE_WIDTH 4096.0
#define TEXTURE_WIDTHI 4096

//#define INV_TEXTURE_WIDTH 0.00048828125
//#define TEXTURE_WIDTH 2048.0

#define INV_TEXTURE_WIDTH_2 2.0 * INV_TEXTURE_WIDTH
#define INV_TEXTURE_WIDTH_3 3.0 * INV_TEXTURE_WIDTH
#define INV_TEXTURE_WIDTH_4 4.0 * INV_TEXTURE_WIDTH

//-----------------------------------------------------------------------

vec3 rayOrigin, rayDirection;
// recorded intersection data:

struct Hit { 
    vec3 hitNormal, hitEmission, hitColor;
    vec2 hitUV;
	vec2 hitPuv;
    float hitObjectID;
	float bh;
    int hitType;
    int hitAlbedoTextureID;
    int hitEmissiveTextureID;
    float hitRoughness;
	float hitIOR;
	float hitMetalness;
};

      
float t;

struct Sphere { vec3 position; float radius; vec3 color; float roughness; vec3 emission; int type;};
struct Light { vec3 position;  float radius; vec3 emission; float attA; vec3 dir;  int type;};

struct Cylinder {vec3 p0; vec3 p1; float radius; vec3 color; float roughness; int type;};
struct Box { vec3 minCorner; vec3 maxCorner; vec3 emission; vec3 color; float roughness; int type; };


int isRayExiting = FALSE;


#include <pathtracing_random_functions_racing>

#include <pathtracing_calc_fresnel_reflectance>

#include <pathtracing_sphere_intersect>

#include <pathtracing_cappedcylinder_intersect>

#include <pathtracing_box_intersect>

#include <pathtracing_boundingbox_intersect>

#include <pathtracing_bvhTriangle_intersect>

#include <pathtracing_sample_sphere_light>


vec2 stackLevels[28];

//vec4 boxNodeData0 corresponds to .x = idTriangle,  .y = aabbMin.x, .z = aabbMin.y, .w = aabbMin.z
//vec4 boxNodeData1 corresponds to .x = idRightChild .y = aabbMax.x, .z = aabbMax.y, .w = aabbMax.z

void GetBoxNodeData(const in float i, inout vec4 boxNodeData0, inout vec4 boxNodeData1)
{
	// each bounding box's data is encoded in 2 rgba(or xyzw) texture slots 
	float ix2 = i * 2.0;
	// (ix2 + 0.0) corresponds to .x = idTriangle,  .y = aabbMin.x, .z = aabbMin.y, .w = aabbMin.z 
	// (ix2 + 1.0) corresponds to .x = idRightChild .y = aabbMax.x, .z = aabbMax.y, .w = aabbMax.z 


	float modi = mod(ix2, TEXTURE_WIDTH);
	float divi = ix2 * INV_TEXTURE_WIDTH;
	
	boxNodeData0 = texelFetch(tAABBTexture, ivec2( modi + 0.0, divi ) , 0);
	boxNodeData1 = texelFetch(tAABBTexture, ivec2( modi + 1.0, divi ) , 0);
}

#define GetBoxNodeDataM(i)  ix2 = i + i; modi = mod(ix2, TEXTURE_WIDTH); divi = ix2 * INV_TEXTURE_WIDTH; currentBoxNodeData0 = texelFetch(tAABBTexture, ivec2( modi + 0.0, divi ) , 0); currentBoxNodeData1 = texelFetch(tAABBTexture, ivec2( modi + 1.0, divi ) , 0);
#define GetBoxNodeDataMA(i) ix2 = i + i; modi = mod(ix2, TEXTURE_WIDTH); divi = ix2 * INV_TEXTURE_WIDTH; nodeAData0 = texelFetch(tAABBTexture, ivec2( modi + 0.0, divi ) , 0); nodeAData1 = texelFetch(tAABBTexture, ivec2( modi + 1.0, divi ) , 0);
#define GetBoxNodeDataMB(i) ix2 = i + i; modi = mod(ix2, TEXTURE_WIDTH); divi = ix2 * INV_TEXTURE_WIDTH; nodeBData0 = texelFetch(tAABBTexture, ivec2( modi + 0.0, divi ) , 0); nodeBData1 = texelFetch(tAABBTexture, ivec2( modi + 1.0, divi ) , 0);

#define BoundingBoxIntersectM(minCorner, maxCorner) near = (minCorner - origin) * inverseDir; far  = (maxCorner - origin) * inverseDir; tmin = min(near, far); tmax = max(near, far); t0 = max( max(tmin.x, tmin.y), tmin.z); t1 = min( min(tmax.x, tmax.y), tmax.z); tout = max(t0, 0.0) > t1 ? INFINITY : t0;

vec3 edge1;
vec3 edge2;
vec3 pvec;
float det;
vec3 tvec;
vec3 qvec;
float tt;

#define BVH_TriangleIntersectM(v0, v1, v2) edge1 = v1 - v0; edge2 = v2 - v0; pvec = cross(dir, edge2); det = 1.0 / dot(edge1, pvec); tvec = origin - v0; tu = dot(tvec, pvec) * det; qvec = cross(tvec, edge1); tv = dot(dir, qvec) * det; tt = dot(edge2, qvec) * det; d = ( det < 0.0 || tu < 0.0 || tu > 1.0 || tv < 0.0 || tu + tv > 1.0 || tt <= 0.0) ? INFINITY : tt;
        
 
void GetGeomData(const in int i, out mat3 im, out vec3 p, out vec4 idxs)
{
	// each bounding box's data is encoded in 2 rgba(or xyzw) texture slots 
	float ix4 = float(i * 4);

	float modi = mod(ix4, TEXTURE_WIDTH);
	float divi = ix4 * INV_TEXTURE_WIDTH;

	ivec2 uv0 = ivec2( modi + 0.0, divi ); // data0
	ivec2 uv1 = ivec2( modi + 1.0, divi ); // m0
	ivec2 uv2 = ivec2( modi + 2.0, divi ); // m1
	ivec2 uv3 = ivec2( modi + 3.0, divi ); // m2
	
	idxs = texelFetch(tMatrixTexture, uv0, 0);
	vec4 v0 = texelFetch(tMatrixTexture, uv1, 0);
	vec4 v1 = texelFetch(tMatrixTexture, uv2, 0);
	vec4 v2 = texelFetch(tMatrixTexture, uv3, 0);
	
	im[0] = v0.xyz;
	im[1] = vec3(v0.w, v1.xy);
	im[2] = vec3(v1.zw, v2.x);
	p = v2.yzw;
}

void GetLight(const in int i, out Light light)
{
	// each light's data is encoded in 3 rgba(or xyzw) texture slots 
	int ix4 = i * 3;
    

	ivec2 uv0 = ivec2( ix4 + 0, 4 ); // position + radius
	ivec2 uv1 = ivec2( ix4 + 1, 4 ); // color + roughness
	ivec2 uv2 = ivec2( ix4 + 2, 4 ); // emission + type
	
	vec4 v0 = texelFetch(tMatrixTexture, uv0, 0);
	vec4 v1 = texelFetch(tMatrixTexture, uv1, 0);
    vec4 v2 = texelFetch(tMatrixTexture, uv2, 0);
		
	light.position = v0.xyz;
	light.radius = v0.w;
	light.emission = v1.xyz;
	light.attA = v1.w;
	light.dir = v2.xyz;
	light.type = int(v2.w);

	
}

void GetSphere(const in int i, out Sphere sphere)
{
	// each sphere's data is encoded in 3 rgba(or xyzw) texture slots 
	int ix4 = i * 3;

 	ivec2 uv0 = ivec2( ix4 + 0, 3 ); // position + radius
	ivec2 uv1 = ivec2( ix4 + 1, 3 ); // color + roughness
	ivec2 uv2 = ivec2( ix4 + 2, 3 ); // emission + type
	
	vec4 v0 = texelFetch(tMatrixTexture, uv0, 0);
	vec4 v1 = texelFetch(tMatrixTexture, uv1, 0);
	vec4 v2 = texelFetch(tMatrixTexture, uv2, 0);
	
	sphere.position = v0.xyz;
	sphere.radius = v0.w;
	sphere.color = v1.xyz;
	sphere.roughness = v1.w;
	sphere.emission = v2.xyz;
	sphere.type = int(v2.w);
	
}

void GetCube(const in int i, out Box box)
{
	// each sphere's data is encoded in 3 rgba(or xyzw) texture slots 
	int ix3 = i * 3;

	ivec2 uv0 = ivec2( ix3 + 0, 5 ); // position + radius
	ivec2 uv1 = ivec2( ix3 + 1, 5 ); // color + roughness
	ivec2 uv2 = ivec2( ix3 + 2, 5 ); // emission + type

	vec4 v0 = texelFetch(tMatrixTexture, uv0, 0);
	vec4 v1 = texelFetch(tMatrixTexture, uv1, 0);
	vec4 v2 = texelFetch(tMatrixTexture, uv2, 0);

	struct Box { vec3 minCorner; vec3 maxCorner; vec3 emission; vec3 color; float roughness; int type; };

	box.minCorner = v0.xyz;
	box.maxCorner = vec3(v0.w, v1.xy);
	box.roughness = v1.z;
	box.type = int(v1.w);

	box.color = v2.xyz;
	box.emission = box.color * 0.1;
}

void GetCylinder(const in int i, out Cylinder cylinder)
{
	// each cylinder's data is encoded in 3 rgba(or xyzw) texture slots 
	int ix3 = i * 3;

	ivec2 uv0 = ivec2( ix3 + 0, 2 ); // position + radius
	ivec2 uv1 = ivec2( ix3 + 1, 2 ); // color + roughness
	ivec2 uv2 = ivec2( ix3 + 2, 2 ); // emission + type

	vec4 v0 = texelFetch(tMatrixTexture, uv0, 0);
	vec4 v1 = texelFetch(tMatrixTexture, uv1, 0);
	vec4 v2 = texelFetch(tMatrixTexture, uv2, 0);

	cylinder.p0 = v0.xyz;
	cylinder.radius = v0.w;

	cylinder.p1 = v1.xyz;
	cylinder.roughness = v1.w;
	
	cylinder.color = v2.xyz;
	cylinder.type = int(v2.w);
}


float hash( vec2 p )
{
	float h = dot(p,vec2(127.1,311.7));	
    	return fract(sin(h)*43758.5453123);
}

float noise( in vec2 p )
{
	vec2 i = floor( p );
	vec2 f = fract( p );	
	vec2 u = f*f*(3.0-2.0*f);
	return -1.0+2.0*mix( mix( hash( i + vec2(0.0,0.0) ), 
		     hash( i + vec2(1.0,0.0) ), u.x),
		mix( hash( i + vec2(0.0,1.0) ), 
		     hash( i + vec2(1.0,1.0) ), u.x), u.y);
}


float s;

//--------------------------------------------------------------------------------------------------------------
float SceneIntersect(const in int bounces, const in vec3 rayOrigin, const in vec3 rayDirection, out Hit hit )
//--------------------------------------------------------------------------------------------------------------
{
	
	vec4 vd0, vd1, vd2, vd3, vd4, vd5, vd6;
	vec3 inverseDir = 1.0 / rayDirection;
	vec3 normal;
	vec3 hitPos, toLightBulb;
	vec4 uv0, uv1, uv2;

	float d;
	float t = INFINITY;
        
	float id = 0.0;
	float id1= 0.0, id2= 0.0, id3= 0.0;
	float tu, tv;
	float triangleID = 0.0;
	vec2 triangleUV = vec2(0.0);
	float triangleMatId = -1.0;
	int geomID = 0;
	float triangleU = 0.0;
	float triangleV = 0.0;
	float triangleW = 0.0;
	float triIOR = 1.0;
	float triMetalness = 0.0;

	vec3 hitDir;

	int objectCount = 0;
	hit.hitObjectID = -INFINITY;

	int triangleLookupNeeded = FALSE;



	
	for (int i = 0; i < uNumSpheres; i++)
    {
		Sphere sphere;
		int ir;

		GetSphere(i, sphere);

		vec3 dL = sphere.position - rayOrigin;
		d = SphereIntersect( sphere.radius, sphere.position, rayOrigin, rayDirection , ir);

		if (d < t)
		{
			t =d;

			isRayExiting = ir;
			hit.hitEmission = sphere.emission ;
			hit.hitNormal = normalize((rayOrigin + rayDirection * t) - sphere.position);
			hit.hitColor = sphere.color;
			hit.hitRoughness = sphere.roughness;
			hit.hitIOR = 1.2;
			hit.hitMetalness = 0.1;
			hit.hitType = sphere.type;
			hit.hitObjectID = float(objectCount);
		}

		objectCount++;
	}
	
	
	/*

	for (int i = 0; i < uNumCylinders; i++)
	{
		int ir;
		Cylinder cylinder;

		GetCylinder(i, cylinder);
 		d = CappedCylinderIntersect( cylinder.p0, cylinder.p1, cylinder.radius, rayOrigin, rayDirection, normal, ir);
		if (d < t)
		{
			t = d;
			hit.hitNormal = normal;
			hit.hitColor = cylinder.color;

			isRayExiting = ir;
			
			hit.hitRoughness = cylinder.roughness;
			hit.hitIOR = 1.2;
			hit.hitMetalness = 0.1;
			hit.hitType = cylinder.type;
			hit.hitObjectID = float(objectCount);
		}
		objectCount++;
	}

	for (int i = 0; i < uNumCubes; i++)
    {
		Box box;
		GetCube(i, box);

		int ir;
		d = BoxIntersect( box.minCorner, box.maxCorner, rayOrigin, rayDirection, normal, ir );
		if (d < t)
		{
			t = d;
			isRayExiting = ir;
			hit.hitNormal = normal;
			hit.hitEmission = box.emission;
			hit.hitColor = box.color;
			hit.hitRoughness = box.roughness;
			hit.hitIOR = 1.4;
			hit.hitMetalness = 0.1;
			hit.hitType = box.type;
			hit.hitObjectID = float(objectCount);
		}
		objectCount++;
	}
	*/

	
	float geostartX = mod(float(uGeoIndex), TEXTURE_WIDTH);
	float geostartY = float(uGeoIndex) * INV_TEXTURE_WIDTH + 9.0;

	for(int g = 0; g < uNumGeometries/4; g ++) {
		mat3 im;
		vec3 pos;
		vec4 idxs;
		float modi, ix2, divi;
    	vec3 near;
        vec3 far;
        vec3 tmin;
        vec3 tmax;
		float tout;
		float tmpW;
		vec2 tmpUV;
		float MatId;
		int geoArray[4];
		
		vec4 geos = texelFetch(tMatrixTexture, ivec2( geostartX + float(g), geostartY), 0);

		geoArray[0] = int(geos.x);
		geoArray[1] = int(geos.y);
		geoArray[2] = int(geos.z);
		geoArray[3] = int(geos.w);

		for(int n=0;n<4;n++){
		
		int ig = geoArray[n];

		if(ig == uIgnoreGeoID)
			continue;
        
        float t0 = max( max(tmin.x, tmin.y), tmin.z);
        float t1 = min( min(tmax.x, tmax.y), tmax.z);

		vec2 currentStackData, stackDataA, stackDataB, tmpStackData;
		vec4 currentBoxNodeData0, nodeAData0, nodeBData0, tmpNodeData0;
		vec4 currentBoxNodeData1, nodeAData1, nodeBData1, tmpNodeData1;
		int skip = FALSE;
		float stackptr = 0.0;

		GetGeomData(ig, im,  pos, idxs);

		vec3 origin = ( im * rayOrigin ) + pos;

		//vec3 camPos = vec3(viewMatrix[ 3 ][ 0 ], viewMatrix[ 3 ][ 1 ], viewMatrix[ 3 ][ 2 ]);
		//vec3 dpos = pos + camPos;
		//vec4 dpos = vec4(pos.x, pos.y, pos.z, 1.0)  * viewMatrix;
		
		if((abs(pos.y) < 300.0)&&(length(origin.xz)> 100.0))
			continue;
		
		float boxOffset = idxs.y;
		
		//GetBoxNodeData(stackptr + boxOffset, currentBoxNodeData0, currentBoxNodeData1);

		GetBoxNodeDataM(stackptr + boxOffset);

		
		vec3 dir = im * rayDirection;
		dir = normalize(dir);
		vec3 inverseDir = 1.0 / dir;

		//BoundingBoxIntersectM(currentBoxNodeData0.yzw, currentBoxNodeData1.yzw);
		//currentStackData = vec2(stackptr, tout);

		currentStackData = vec2(stackptr, BoundingBoxIntersect(currentBoxNodeData0.yzw, currentBoxNodeData1.yzw, origin, inverseDir));

		stackLevels[0] = currentStackData;
		skip = (currentStackData.y < t) ? TRUE : FALSE;

		int nIters = 0;

		while (true)
		{
			if (skip == FALSE) 
			{
				// decrease pointer by 1 (0.0 is root level, 27.0 is maximum depth)
				if (--stackptr < 0.0) // went past the root level, terminate loop
					break;

				currentStackData = stackLevels[int(stackptr)];
				
				if (currentStackData.y >= t)
					continue;
				
				//GetBoxNodeData(currentStackData.x + boxOffset, currentBoxNodeData0, currentBoxNodeData1);
				GetBoxNodeDataM(currentStackData.x + boxOffset);
			}
			skip = FALSE; // reset skip
			
			if (currentBoxNodeData0.x < 0.0) // < 0.0 signifies an inner node
			{
				//GetBoxNodeData(currentStackData.x + 1.0 + boxOffset, nodeAData0, nodeAData1);
				//GetBoxNodeData(currentBoxNodeData1.x + boxOffset, nodeBData0, nodeBData1);

				GetBoxNodeDataMA(currentStackData.x + 1.0 + boxOffset);
				GetBoxNodeDataMB(currentBoxNodeData1.x + boxOffset);

				stackDataA = vec2(currentStackData.x + 1.0, BoundingBoxIntersect(nodeAData0.yzw, nodeAData1.yzw, origin, inverseDir));
				stackDataB = vec2(currentBoxNodeData1.x, BoundingBoxIntersect(nodeBData0.yzw, nodeBData1.yzw, origin, inverseDir));

				/*
				BoundingBoxIntersectM(nodeAData0.yzw, nodeAData1.yzw);
				stackDataA = vec2(currentStackData.x + 1.0, tout);

				BoundingBoxIntersectM(nodeBData0.yzw, nodeBData1.yzw);
				stackDataB = vec2(currentBoxNodeData1.x, tout);
				*/
								
				// first sort the branch node data so that 'a' is the smallest
				if (stackDataB.y < stackDataA.y)
				{
					tmpStackData = stackDataB;
					stackDataB = stackDataA;
					stackDataA = tmpStackData;

					tmpNodeData0 = nodeBData0;   tmpNodeData1 = nodeBData1;
					nodeBData0   = nodeAData0;   nodeBData1   = nodeAData1;
					nodeAData0   = tmpNodeData0; nodeAData1   = tmpNodeData1;
				} // branch 'b' now has the larger rayT value of 'a' and 'b'

				if (stackDataB.y < t) // see if branch 'b' (the larger rayT) needs to be processed
				{
					currentStackData = stackDataB;
					currentBoxNodeData0 = nodeBData0;
					currentBoxNodeData1 = nodeBData1;
					skip = TRUE; // this will prevent the stackptr from decreasing by 1
				}
				if (stackDataA.y < t) // see if branch 'a' (the smaller rayT) needs to be processed 
				{
					if (skip == TRUE) // if larger branch 'b' needed to be processed also,
						stackLevels[int(stackptr++)] = stackDataB; // cue larger branch 'b' for future round
								// also, increase pointer by 1
					
					currentStackData = stackDataA;
					currentBoxNodeData0 = nodeAData0; 
					currentBoxNodeData1 = nodeAData1;
					skip = TRUE; // this will prevent the stackptr from decreasing by 1
				}

				continue;
			} // end if (currentBoxNodeData0.x < 0.0) // inner node


			// else this is a leaf

			// each triangle's data is encoded in 16 rgba(or xyzw) texture slots

			/*
			if(uIndexedGeometry == 1){
				id = (currentBoxNodeData0.x + idxs.x);
				vec4 tri = texelFetch(tTriangleTexture, ivec2( mod(id, TEXTURE_WIDTH), id * INV_TEXTURE_WIDTH), 0);

				id1 = (idxs.z + tri.x) * 2.0;
				id2 = (idxs.z + tri.y) * 2.0;
				id3 = (idxs.z + tri.z) * 2.0;
				MatId = tri.w * 4.0;
					
				vd0 = texelFetch(tTriangleTexture, ivec2( mod(id1 + 0.0, TEXTURE_WIDTH), (id1 + 0.0) * INV_TEXTURE_WIDTH), 0);
				vd1 = texelFetch(tTriangleTexture, ivec2( mod(id2 + 0.0, TEXTURE_WIDTH), (id2 + 0.0) * INV_TEXTURE_WIDTH), 0);
				vd2 = texelFetch(tTriangleTexture, ivec2( mod(id3 + 0.0, TEXTURE_WIDTH), (id3 + 0.0) * INV_TEXTURE_WIDTH), 0);
				
				BVH_TriangleIntersectM( vd0.xyz, vd1.xyz, vd2.xyz);
			}else{
			*/
				id = 4.0 * (currentBoxNodeData0.x + idxs.x);
				vd0 = texelFetch(tTriangleTexture, ivec2( mod(id + 0.0, TEXTURE_WIDTH), (id + 0.0) * INV_TEXTURE_WIDTH), 0);
				vd1 = texelFetch(tTriangleTexture, ivec2( mod(id + 1.0, TEXTURE_WIDTH), (id + 1.0) * INV_TEXTURE_WIDTH), 0);
				vd2 = texelFetch(tTriangleTexture, ivec2( mod(id + 2.0, TEXTURE_WIDTH), (id + 2.0) * INV_TEXTURE_WIDTH), 0);
		
				MatId = vd2.y * 4.0;

				BVH_TriangleIntersectM( vec3(vd0.xyz), vec3(vd0.w, vd1.xy) , vec3(vd1.zw, vd2.x) );
			//}

			float transparent = 0.0;

			if(MatId >= 400000.0){
				MatId -= 400000.0;
				transparent = 1.0;
			}
			
			if (d < t) {

				float tw = 1.0 - tu - tv;

				/*
				if(uIndexedGeometry == 1){
					uv1 = texelFetch(tTriangleTexture, ivec2( mod(id2 + 1.0, TEXTURE_WIDTH), (id2 + 1.0) * INV_TEXTURE_WIDTH), 0);
					uv0 = texelFetch(tTriangleTexture, ivec2( mod(id1 + 1.0, TEXTURE_WIDTH), (id1 + 1.0) * INV_TEXTURE_WIDTH), 0);
					uv2 = texelFetch(tTriangleTexture, ivec2( mod(id3 + 1.0, TEXTURE_WIDTH), (id3 + 1.0) * INV_TEXTURE_WIDTH), 0);
					
					vec2 uv = tw * vec2(vd0.w, uv0.x) + tu * vec2(vd1.w, uv1.x) + tv * vec2(vd2.w, uv2.x);
				}else{
					vd3 = texelFetch(tTriangleTexture, ivec2( mod(id + 3.0, TEXTURE_WIDTH), (id + 3.0) * INV_TEXTURE_WIDTH), 0);
					vec2 uv = tw * vd2.zw + tu * vd3.xy + tv * vd3.zw;
				}
				*/

				
				/*
				
				if(transparent > 0.0){

					vec2 fracuv = fract( uv);

					if(fracuv.x<0.0)
						fracuv.x += 1.0;

					if(fracuv.y<0.0)
						fracuv.y += 1.0;

					float modi = mod(MatId, TEXTURE_WIDTH);
					float divi = MatId * INV_TEXTURE_WIDTH + 6.0;
					vec4 mater3 = texelFetch(tMatrixTexture, ivec2( modi + 3.0, divi), 0);

					int hitAlphaTextureID = int(mater3.y);

					if(hitAlphaTextureID>=0){
						vec4 pos = texelFetch(tMatrixTexture, ivec2(hitAlphaTextureID, 8 * INV_TEXTURE_WIDTH), 0); //uAlbedoCoords[hitAlphaTextureID];
						vec2 tuv = pos.xy + fracuv * pos.zw;

						float alpha =  texture(tAlbedoTexture, tuv).r;
						
						if(alpha < 0.3)
							continue;
						
					}
				}*/
				

				triangleUV = vd2.zw;
				triangleID = id;
				triangleU = tu;
				triangleV = tv;
				triangleW = tw;
				triangleMatId = MatId;
				triangleLookupNeeded = TRUE;
				hitDir = dir;
				geomID = ig;
				t = d;
			}
			
		} // end while (TRUE)
		}
	}

	if (triangleLookupNeeded == TRUE)
	{
      	float modi = mod(triangleMatId, TEXTURE_WIDTH);
		float divi = triangleMatId * INV_TEXTURE_WIDTH + 6.0;

		vec4 mater0 = texelFetch(tMatrixTexture, ivec2( modi + 0.0, divi), 0);
		vec4 mater1 = texelFetch(tMatrixTexture, ivec2( modi + 1.0, divi), 0);
		vec4 mater2 = texelFetch(tMatrixTexture, ivec2( modi + 2.0, divi), 0);
		vec4 mater3 = texelFetch(tMatrixTexture, ivec2( modi + 3.0, divi), 0);

		vec4 vd3 = texelFetch(tTriangleTexture, ivec2( mod(triangleID + 3.0, TEXTURE_WIDTH), (triangleID + 3.0) * INV_TEXTURE_WIDTH), 0);
		vec2 ltriangleUV = triangleW * triangleUV + triangleU * vd3.xy + triangleV * vd3.zw;
		
		// interpolated normal using triangle intersection's uv's
		hit.hitUV = vec2(ltriangleUV.x + mater3.z, ltriangleUV.y + mater3.w);
		hit.hitAlbedoTextureID = int(mater1.x);
		hit.hitEmissiveTextureID = int(mater1.y);

		vec2 fracuv = fract( hit.hitUV);

		if(fracuv.x<0.0)
			fracuv.x += 1.0;

		if(fracuv.y<0.0)
			fracuv.y += 1.0;

		if(hit.hitEmissiveTextureID < 0) {

			hit.hitEmission = vec3(mater1.w, mater2.xy) * mater3.x;

			if(hit.hitAlbedoTextureID < 0) {
				hit.hitColor = mater0.yzw;
			} else {
				
				vec4 pos = texelFetch(tMatrixTexture, ivec2(hit.hitAlbedoTextureID, 8.0), 0); //uAlbedoCoords[hit.hitAlbedoTextureID];
				vec2 tuv = pos.xy + fracuv * pos.zw;
				hit.hitColor = mater0.yzw *  texture(tAlbedoTexture, tuv).rgb;

				/*
				int tid = uAlbedoTexturesIds[hit.hitAlbedoTextureID];
				switch(tid){
					case 0: hit.hitColor = mater0.yzw *  texture(tAlbedoTextures[0], tuv).rgb; break;
					case 1: hit.hitColor = mater0.yzw *  texture(tAlbedoTextures[1], tuv).rgb; break;
					case 2: hit.hitColor = mater0.yzw *  texture(tAlbedoTextures[2], tuv).rgb; break;
				}
				*/
			}

		} else {

			hit.hitColor = vec3(0.0, 0.0, 0.0);

		
			vec4 pos = texelFetch(tMatrixTexture, ivec2(hit.hitEmissiveTextureID, 8.0), 0); //uAlbedoCoords[hit.hitEmissiveTextureID];
			vec2 tuv = pos.xy + fracuv * pos.zw;
			hit.hitEmission = texture(tAlbedoTexture, tuv).rgb * mater3.x;

			/*
			int tid = uAlbedoTexturesIds[hit.hitEmissiveTextureID];
			switch(tid){
				case 0: hit.hitEmission = texture(tAlbedoTextures[0], tuv).rgb * mater3.x; break;
				case 1: hit.hitEmission = texture(tAlbedoTextures[1], tuv).rgb * mater3.x; break;
				case 2: hit.hitEmission = texture(tAlbedoTextures[2], tuv).rgb * mater3.x; break;
			}
			*/
		}

		hit.hitRoughness = mater1.z;
		hit.hitIOR = mater2.z;
		hit.hitMetalness = mater2.w;
		hit.hitObjectID = float(objectCount + geomID) ;
		hit.hitType = int(mater0.x);
		
	}

	return t;

} // end float SceneIntersect( out float hitObjectID )
`;
export {shader};